
import { createMuiTheme } from '@material-ui/core/styles';

export const BrightBackground = '#f3f6fc';

const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#11a8d3',
            contrastText: '#ffffff'
        },
        secondary: {
            main: '#555555',
        },
        common: {
            black: '#000',
            white: '#fff'
        },
        text: {
            primary: '#000000',
            secondary: '#555555'
        },
        background: {
            default: '#d3e1f1',
            paper: '#ffffff'
        },
        type: 'light',
        action:  {
            active: 'rgba(0, 0, 0, 0.54)',
            hover: '#fffcd8',
            hoverOpacity: 0.08,
            selected: '#ffefbb',
            disabled: 'rgba(0, 0, 0, 0.26)',
            disabledBackground: 'rgba(0, 0, 0, 0.12)',
        },
        divider: '#99bce8',
    },
    typography: {
        useNextVariants: true,
        fontSize: 14,
        htmlFontSize: 16,
    },
    shape: {
        borderRadius: 12
    }
});

theme.overrides = {
    MuiButton: { // Name of the component ⚛️ / style sheet
        outlined: { // Name of the rule
            color: theme.palette.text.secondary, // Some CSS
            textTransform: 'none',
            padding: `0 ${theme.spacing.unit}px`,
            minWidth: 100,
            borderRadius: theme.shape.borderRadius,
        },
    },
    MuiIconButton: {
        root: {
            padding: 0,
            fontSize: 'inherit'
        }
    },
    MuiSvgIcon: {
        root: {
            margin: theme.spacing.unit / 2,
            fontSize: 'inherit'
        }
    },
    MuiInputBase: {
        root: {
            backgroundColor: theme.palette.common.white,
            borderStyle: 'solid',
            borderColor: theme.palette.text.secondary,
            borderRadius: theme.shape.borderRadius,
            borderWidth: 1,
            padding: '0 8px',
            '&:hover': {
                borderColor: theme.palette.primary.main
            }
        },
        disabled: {
            '&:hover': {
                borderColor: 'inherit'
            }
        },
        input: {
            padding: 0,
            cursor: 'text',
            fontSize: 14,
        },
        focused: {
            borderColor: theme.palette.primary.main
        },
        multiline: {
            padding: '0 8px',
        },
    },
    MuiCheckbox: {
        root: {
            color: theme.palette.primary.main
        }
    },
    MuiTableRow: {
        root: {
            padding: 4,
            height: 20,
            border: 'none',
            '&:nth-of-type(even)': {
                backgroundColor: BrightBackground,
            },
        },
        head: {
            height: 20,
        },
    },
    MuiTableCell: {
        head: {
            color: theme.palette.grey[500],
        },
        body: {
            fontSize: 14,
        },
        root: {
            padding: 4,
            border: 'none',
            borderBottom: 'none'
        }
    },
    MuiToolbar: {
        dense: {
            minHeight: 34,
            fontSize: 24,
            padding: 0,
            display: 'flex',
            justifyContent: 'space-evenly',
        },
    },
    MuiPaper: {
        root: {
            boxShadow: 'none !important',
            position: 'relative'
        },
        rounded: {
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: 3,
        }
    },
    MuiTooltip: {
        tooltip: {
            fontSize: 14,
        },
    },
    MuiTableHead: {
        root: {
            borderBottom: `1px solid ${theme.palette.divider}`,
        },
    },
};

export default theme;
